<div class="text-slate-900 text-sm text-center">

  <div class="bg-slate-700 h-14">

  </div>

  <div class="absolute bottom-0 left-0 right-0 flex justify-center items-center gap-6 pb-2">
    <div class="border-8 rounded-full border-slate-700" >
      <a mat-fab [color]="getColor('rooms')" routerLink="/rooms" matTooltip="Rooms">
        <fa-icon icon="chalkboard-user" size="lg"></fa-icon>
      </a>
    </div>

    <div class="border-8 rounded-full border-slate-700" >
      <a mat-fab [color]="getColor('home')" routerLink="/" matTooltip="Home">
        <fa-icon icon="home" size="lg"></fa-icon>
      </a>
    </div>

    <div class="border-8 rounded-full border-slate-700">
      <a mat-fab [color]="getColor('groupmates')" routerLink="/groupmates" matTooltip="Groupmates">
        <fa-icon icon="user-group" size="lg"></fa-icon>
      </a>
    </div>
  </div>



</div>
